import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';


Vue.use(Vuex)

export const store = new Vuex.Store({
	state:{
		downtext:false,
		downexam:false,
		forceFresh:false,
		activeIndex:'',
		headerIndex:'',
		danwei:[],
		cheliang:[],
		xueyuan:[],
		sext:[],
		sextall:[],
		study:[],
		ny:[],
		nyh:[],
		nyf:[],
		exam:[],
		examall:[],
		sexam:[],
		admin:[],
		info:[],
		now:'',
		yh:[]
	},
	getters: {
		getShsn: (state) => {
			let num=0;
		  	state.study.forEach((v,i) => {
		  		if (v.studylog == "未通过" && v.ny == state.now) num++;
		  	})
		  	return num;
		},
		getShsd: (state) => {
			let num=0;
		  	state.study.forEach((v,i) => {
		  		if (v.studylog == "已通过" && v.ny == state.now) num++;
		  	})
		  	return num;
		},
		getShs: (state) => {
			let num=0;
		  	state.study.forEach((v,i) => {
		  		if (v.ny == state.now) num++;
		  	})
		  	return num;
		},

		getClsn: (state) => {
			let num=0;
		  	state.cheliang.forEach((v,i) => {
		  		if (v.zt === "停运") num++;
		  	})
		  	return num || 0;
		},
		getClsd: (state) => {
			let num=0;
		  	state.cheliang.forEach((v,i) => {
		  		if (v.zt === "正常") num++;
		  	})
		  	return num || 0;
		},
		getXysn: (state) => {
			let num=0;
		  	state.xueyuan.forEach((v,i) => {
		  		if (v.studylog == "0分钟") num++;
		  	})
		  	return num || 0;
		},
		getXysd: (state) => {
			let num=0;
		  	state.xueyuan.forEach((v,i) => {
		  		if (v.studylog == "已完成") num++;
		  	})
		  	return num || 0;
		},
	  getTextall: (state) => (name,mod) => {
	  	if (mod == "1") return state.sextall.filter(todo => todo.name.indexOf(name)>=0 || todo.lx.indexOf(name)>=0);
	  	else if (mod == "2") return state.sextall.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.sextall.filter(todo => todo.lx.indexOf(name)>=0);
	  },
	  getExamall: (state) => (name,mod) => {
	  	if (mod == "1") return state.examall.filter(todo => todo.name.indexOf(name)>=0 || todo.lx.indexOf(name)>=0);
	  	else if (mod == "2") return state.examall.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.examall.filter(todo => todo.lx.indexOf(name)>=0);
	  },
		getTextlog: (state) => (studylog) => {
  			let textlog = [];
  			studylog.forEach((v,i) => {
  				if (i>0 && v){
  					state.sext.forEach((v2,i2) => {
  						if (v2.id == i) {
  							let time = Math.ceil(v/60);
  							textlog.push({name:v2.name,time:time});
  						}
  					});
  				}
  			});
  			return textlog;
		},
		getFace: (state) => (xyid) => {
			for (let v of state.xueyuan) {
				if (v.id == xyid && v.face) return '/apis/'+v.face;
			}
		},
	  getAdmin: (state) => (name,mod) => {
	  	if (mod == "1") return state.admin.filter(todo => todo.dw.indexOf(name)>=0 || todo.name.indexOf(name)>=0);
	  	else if (mod == "2") return state.admin.filter(todo => todo.dw.indexOf(name)>=0);
	  	else if (mod == "3") return state.admin.filter(todo => todo.name.indexOf(name)>=0);
	  },
	  getSexam: (state) => (name,mod) => {
	  	if (mod == "1") return state.sexam.filter(todo => todo.name.indexOf(name)>=0 || todo.cph.indexOf(name)>=0 || todo.ktname.indexOf(name)>=0);
	  	else if (mod == "2") return state.sexam.filter(todo => todo.ktname.indexOf(name)>=0);
	  	else if (mod == "3") return state.sexam.filter(todo => todo.cph.indexOf(name)>=0);
	  	else if (mod == "4") return state.sexam.filter(todo => todo.name.indexOf(name)>=0);
	  },
	  getExam: (state) => (name,mod) => {
	  	if (mod == "1") return state.exam.filter(todo => todo.name.indexOf(name)>=0 || todo.lx.indexOf(name)>=0);
	  	else if (mod == "2") return state.exam.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.exam.filter(todo => todo.lx.indexOf(name)>=0);
	  },
	  getStudy: (state) => (name,mod) => {
	  	if (mod == "1") return state.study.filter(todo => todo.name.indexOf(name)>=0 || todo.cph.indexOf(name)>=0 || todo.ny.indexOf(name)>=0);
	  	else if (mod == "2") return state.study.filter(todo => todo.cph.indexOf(name)>=0);
	  	else if (mod == "3") return state.study.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.study.filter(todo => todo.ny.indexOf(name)>=0);
	  },
	  getStudyByXyid: (state) => (id, ny) => {
	  	return state.study.filter(todo => todo.xyid == id);
	  },
	  getYh: (state) => (name,mod) => {
	  	if (mod == "1") return state.yh.filter(todo => todo.name.indexOf(name)>=0 || todo.cph.indexOf(name)>=0 || todo.ny.indexOf(name)>=0);
	  	else if (mod == "2") return state.yh.filter(todo => todo.cph.indexOf(name)>=0);
	  	else if (mod == "3") return state.yh.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.yh.filter(todo => todo.ny.indexOf(name)>=0);
	  },
	  getText: (state) => (name,mod) => {
	  	if (mod == "1") return state.sext.filter(todo => todo.name.indexOf(name)>=0 || todo.lx.indexOf(name)>=0);
	  	else if (mod == "2") return state.sext.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.sext.filter(todo => todo.lx.indexOf(name)>=0);
	  },
	  getInfo: (state) => (name,mod) => {
	  	if (mod == "1") return state.info.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "2") return state.info.filter(todo => todo.name.indexOf(name)>=0);
	  },
	  getDanwei: (state) => (name,mod) => {
	  	if (mod == "1") return state.danwei.filter(todo => todo.name.indexOf(name)>=0 || todo.lianxiren.indexOf(name)>=0);
	  	else if (mod == "2") return state.danwei.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.danwei.filter(todo => todo.lianxiren.indexOf(name)>=0);
	  },
	  getCheliang: (state) => (name,mod) => {
	  	if (state.danwei.length > 0){
		  	state.cheliang.forEach((v,i) => {
		  		state.cheliang[i].name = store.getters.getDanweiName(v.ssdw.replace("danwei",""));
		  		if (!state.cheliang[i].name) state.cheliang[i].ssdw = ""
		  	})
		  }
	  	if (mod == "1") return state.cheliang.filter(todo => todo.cph.indexOf(name)>=0 || todo.name.indexOf(name)>=0 || todo.cpys.indexOf(name)>=0);
	  	else if (mod == "2") return state.cheliang.filter(todo => todo.cph.indexOf(name)>=0);
	  	else if (mod == "3") return state.cheliang.filter(todo => todo.ssdw.indexOf(name)>=0);
	  	else if (mod == "4") return state.cheliang.filter(todo => todo.cpys.indexOf(name)>=0);
	  },
	  getXueyuan: (state) => (name,mod) => {
	  	if (state.cheliang.length > 0){
		  	state.xueyuan.forEach((v,i) => {
		  		var vname = "";
		  		v.glcl.forEach((vj,j) =>{
		  			var cname = store.getters.getCheliangName(vj.replace("cheliang",""));
		  			if (cname) vname += cname+",";
		  			else state.xueyuan[i].glcl.splice(j,1);
		  		});
		  		state.xueyuan[i].clname = vname.substring(0, vname.lastIndexOf(','));
		  		if (state.xueyuan[i].clname == "") state.xueyuan[i].glcl = [];
		  	});
		  }
	  	if (mod == "1") return state.xueyuan.filter(todo => todo.name.indexOf(name)>=0 || todo.zjh.indexOf(name)>=0 || todo.clname.indexOf(name)>=0);
	  	else if (mod == "2") return state.xueyuan.filter(todo => todo.name.indexOf(name)>=0);
	  	else if (mod == "3") return state.xueyuan.filter(todo => todo.zjh.indexOf(name)>=0);
	  	else if (mod == "4") return state.xueyuan.filter(todo => todo.clname.indexOf(name)>=0);
	  },
	  getDanweiName: (state) => (id) => {
		for( let v of state.danwei){
	  		if (id == v.id) return v.name;
		}
	  	return null;
	  },
	  getCheliangName: (state) => (id) => {
		for( let v of state.cheliang){
	  		if (id == v.id) return v.cph;
		}
	  	return null;
	  },
	  getExamContent: (state) => (id) => {
		for( let v of state.exam){
	  		if (id == v.id) return v;
		}
	  	return null;
	  },
	  getTextContent: (state) => (id) => {
		for( let v of state.sext){
	  		if (id == v.id) return v;
		}
	  	return null;
	  },
	  getInfoContent: (state) => (id) => {
		for( let v of state.info){
	  		if (id == v.id) return v;
		}
	  	return null;
	  },
	  getRenyuan: (state) => (id,lx) => {
	  	var result = false;
		for( let v of state.xueyuan){
	  		v.glcl.forEach((vj,j) =>{
	  			var cid = vj.replace("cheliang","");
	  			if (id == cid && v.lx == lx) result = true;
	  		});
		}
	  	return result;
	  },
	},
	mutations: {
		setYh(state, val) {
			state.yh = [];
			val.forEach((v,i) => {
				let str = v.data.replace(/[\r\n]/g, "");
				state.yh[i] = JSON.parse(str);
				state.yh[i] = {...state.yh[i],...JSON.parse(v.src)};
				state.yh[i].cph = v.cph;
				state.yh[i].id = v.id;
				state.yh[i].ny = v.ny;
				state.yh[i].ym = v.ym;
		        // var date = new Date(Number(v.ny)*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		        // var Y = date.getFullYear();
		        // var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
		        // var str = Y+M;
		        // if (str.indexOf("NaN") != -1) state.yh[i].nyh = null;
		        // else state.yh[i].nyh = str;
		        if (state.nyh.indexOf(v.ym) == -1) state.nyh.push(v.ym);
			});
		},
	  setTextall(state, val) {
	    state.sextall = val;
	  	state.sextall.forEach((v,i) => {
	  		state.sextall[i].gllxname = v.gllx;
	  		if (v.gllx) state.sextall[i].gllx = v.gllx == "" ? [] : v.gllx.split(',');
	  	});
	  },
	  setExamall(state, val) {
	    state.examall = val;
	  	state.examall.forEach((v,i) => {
	  		state.examall[i].gllxname = v.gllx;
	  		if (v.gllx) state.examall[i].gllx = v.gllx == "" ? [] : v.gllx.split(',');
	  	});
	  },
	  setAdmin(state, val) {
	    state.admin = val;
	  },
	  editAdmin(state, val) {
	  	state.admin.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			v.name = val.name;
	  			v.dw = val.dw;
	  			v.max = val.max;
	  			state.admin[i] = v;
	  		}
	  	});
	  },
	  delAdmin(state, val) {
	  	state.admin.forEach((v,i) => {
	  		if (v.id == val.id) state.admin.splice(i,1);
	  	})
	  },
	  setSexam(state, val) {
	    state.sexam = val;
	  },
	  setExam(state, val) {
	    state.exam = val;
	  	state.exam.forEach((v,i) => {
	  		state.exam[i].gllxname = v.gllx;
	  		if (v.gllx) state.exam[i].gllx = v.gllx == "" ? [] : v.gllx.split(',');
	  	});
	  },
	  delExam(state, val) {
	  	// console.log(state.sext);
	  	state.exam.forEach((v,i) => {
	  		if (v.id == val.id) state.exam.splice(i,1);
	  	})
	  },
	  editExam(state, val) {
	  	state.exam.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			v.name = val.name;
	  			v.lx = val.lx;
	  			v.gllx = val.gllx;
	  			v.gllxname = val.gllxname;
	  			v.zt = val.zt;
	  			v.time = val.time;
	  			v.text = val.text;
	  			state.exam[i] = v;
	  			// console.log(v.gllxname);
	  		}
	  	});
	  },
	  setStudy(state, val) {
	  	state.ny = [];
	  	state.nyf = [];
	    state.study = val;
	  	state.study.forEach((v,i) => {
	  		if (state.ny.indexOf(v.ny) == -1) {
	  			state.nyf.push({text: v.ny, value: v.ny});
	  			state.ny.push(v.ny);
	  		}
	  		state.study[i].studylog = JSON.parse(v.studylog);
	  	});
	  },
	  delStudy(state, val) {
	  	state.study.forEach((v,i) => {
	  		if (v.id == val.id) state.study.splice(i,1);
	  	})
	  },
	  delYh(state, val) {
	  	state.yh.forEach((v,i) => {
	  		if (v.id == val.id) state.yh.splice(i,1);
	  	})
	  },
	  editStudy(state, val) {
	  	state.study.forEach((v,i) => {
	  		// console.log(v,val);
	  		if (v.id == val.id) state.study[i].zt = val.zt;
	  	});
	  },

	  setInfo(state, val) {
	    state.info = val;
	  	state.info.forEach((v,i) => {
	  		state.info[i].gllxname = v.gllx;
	  		if (v.gllx) state.info[i].gllx = v.gllx == "" ? [] : v.gllx.split(',');
	  	});
	  },
	  delInfo(state, val) {
	  	state.info.forEach((v,i) => {
	  		if (v.id == val.id) state.info.splice(i,1);
	  	})
	  },
	  editInfo(state, val) {
	  	state.info.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			v.name = val.name;
	  			v.lx = val.lx;
	  			v.gllx = val.gllx;
	  			v.gllxname = val.gllxname;
	  			v.zt = val.zt;
	  			v.text = val.text;
	  			state.info[i] = v;
	  			// console.log(v.gllxname);
	  		}
	  	});
	  },

	  setText(state, val) {
	    state.sext = val;
	  	state.sext.forEach((v,i) => {
	  		state.sext[i].gllxname = v.gllx;
	  		if (v.gllx) state.sext[i].gllx = v.gllx == "" ? [] : v.gllx.split(',');
	  	});
	  },
	  delText(state, val) {
	  	console.log(state.sext);
	  	state.sext.forEach((v,i) => {
	  		if (v.id == val.id) state.sext.splice(i,1);
	  	})
	  },
	  editText(state, val) {
	  	state.sext.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			v.name = val.name;
	  			v.lx = val.lx;
	  			v.gllx = val.gllx;
	  			v.gllxname = val.gllxname;
	  			v.time = val.time;
	  			v.zt = val.zt;
	  			v.text = val.text;
	  			state.sext[i] = v;
	  			// console.log(v.gllxname);
	  		}
	  	});
	  },
	  setDanwei(state, val) {
	    state.danwei = val;
	  },
	  delDanwei(state, val) {
	  	state.danwei.forEach((v,i) => {
	  		if (v.id == val.id) state.danwei.splice(i,1);
	  	})
	  },
	  editDanwei(state, val) {
	  	state.danwei.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			v.name = val.name;
	  			v.lianxiren = val.lianxiren;
	  			state.danwei[i] = v;
	  		}
	  	});
	  },
	  setCheliang(state, val) {
	    state.cheliang = val;
	  },
	  delCheliang(state, val) {
	  	state.cheliang.forEach((v,i) => {
	  		if (v.id == val.id) state.cheliang.splice(i,1);
	  	})
	  },
	  editCheliang(state, val) {
	  	state.cheliang.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			// state.cheliang[i].name = state.danwei[val.id].name;
	  			state.cheliang[i].cph = val.cph;
	  			state.cheliang[i].ssdw = val.ssdw;
	  			state.cheliang[i].cpys = val.cpys;
	  			state.cheliang[i].lx = val.lx;
	  			state.cheliang[i].zt = val.zt;
	  		}
	  	});
	  },
	  setXueyuan(state, val) {

        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month >= 1 && month <= 9) month = "0" + month;
        var currentdate = year + '' + month;

	    state.xueyuan = val;
	  	state.xueyuan.forEach((v,i) => {
	  		try{
		  		state.xueyuan[i].glcl = v.glcl == "" ? [] : v.glcl.split(',');
		  		state.xueyuan[i].studylog = JSON.parse(state.xueyuan[i].studylog) || [0];
		  		if (state.xueyuan[i].ny != currentdate) state.xueyuan[i].studylog = "0分钟";
		  		else if (Math.ceil(Number(v.studylog[0]/60)) >= 40) state.xueyuan[i].studylog = "已完成";
		  		else state.xueyuan[i].studylog = parseInt(Number(v.studylog[0]/60))+"分钟";
		  	}
		    catch(err){
		    	print('【'+state.xueyuan[i].name+'】数据错误，请检查');
		    }
	  	});
	  },
	  delXueyuan(state, val) {
	  	state.xueyuan.forEach((v,i) => {
	  		if (v.id == val.id) state.xueyuan.splice(i,1);
	  	})
	  },
	  editXueyuan(state, val) {
	  	state.xueyuan.forEach((v,i) => {
	  		if (v.id == val.id) {
	  			state.xueyuan[i].name = val.name;
	  			state.xueyuan[i].zjh = val.zjh;
	  			state.xueyuan[i].glcl = val.glcl;
	  			state.xueyuan[i].lx = val.lx;
	  			state.xueyuan[i].zt = val.zt;
	  			state.xueyuan[i].password = val.password;
	  		}
	  	});
	  }
	},
	modules: {
	user
	}
});



// WEBPACK FOOTER //
// ./src/store/store.js